import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import Portlet from '../../utils/portlet';
// import {compose, graphql} from "react-apollo/index";
import { compose, withApollo, graphql } from "react-apollo";
import {API_TOKEN} from "./gql/query";
import { FormattedMessage, injectIntl } from "react-intl";
import { Input, Form, Select, Button, message, Col, Row } from "antd";

import {Loading} from "../../utils/loading";
class IntegrationMenu extends React.Component {
    constructor (props){
        super(props);
        this.state = {};
    }

    render (){
        const {apiToken} = this.props.apiToken;
        return (
            <div className='page'>
                <BreadcrumbsItem to='/dashboard/integration' className='ant-breadcrumb-link'>
                    <FormattedMessage id="user-menu.integration" defaultMessage="Integration"/>
                </BreadcrumbsItem>
                <Row className="profile-page__wrap" justify="space-between" type="flex">
                    {!!apiToken?
                    <div>
                        API Token: {apiToken}
                    </div>:
                    <div>
                        API Token: <Loading/>
                    </div>
                    }
                </Row>
            </div>
        )
    }
};

const Integration = compose(
  withApollo,
  graphql(API_TOKEN, {
    name: 'apiToken'
  }),
)(injectIntl(IntegrationMenu));

export default Integration;


// WEBPACK FOOTER //
// ./src/components/dashboard/integration/index.js